<template>
  <div>
		<div class="separator separator--mobile">
			<div class="page-wrapper">
				<div class="infobox">
					<div class="infobox__col">
						<section class="section-wrapper section-wrapper--infinite">
						<h1 class="title" v-html="$t('support.introducerTitle')"></h1>
						<p class="text u-weight-bold" v-html="$t('support.introducerText1')"></p>
						<p class="text" v-html="$t('support.introducerText2')"></p>
						</section>
					</div>
					<div class="infobox__col">
						<img src="@/assets/pages/support/introducer.jpg" class="infobox__image"/>
					</div>
				</div>
			</div>
		</div>

		<div id="contact-form" class="separator separator--background contact-form contact-form--support">
			<div class="contact-form__wrapper page-wrapper">
				<div class="contact-form__form">
					<h1 class="title l-pb-20">{{ $t('support.formTitle') }}</h1>
					<div :class="{ 'contact-form__success--visible': formSent }" class="contact-form__success">{{ $t('support.success') }}</div>
					<form @submit.prevent="submitForm">
						<label class="form__label">{{ $t('support.formName') }}</label>
						<input v-model="name" type="text" class="form__input" autocomplete="name" required/>

						<label class="form__label">{{ $t('support.formEmail') }}</label>
						<input v-model="email" type="email" class="form__input" autocomplete="email" required/>

						<label class="form__label">{{ $t('support.formMessage') }}</label>
						<textarea v-model="message" class="form__textarea" required></textarea>

						<div id="g-recaptcha" class="g-recaptcha" data-sitekey="6Ld-FbYpAAAAAIWvGa2WQrAILIyRzg8IIcJmW9Ba"></div>
						<input type="submit" class="l-mt-15 button button--large" :value="$t('support.formSubmit')"/>
					</form>
				</div>
				<section class="contact-form__info">
					<div class="contact-form__addresses">
						<address class="contact-form__address">
							<h2 class="">{{ $t('support.salesCustomerService') }}</h2>
							<!-- <p class="text">{{ $t('support.phone') }}</p> -->
							<p class="text">{{ $t('support.openingHours') }}</p>
							<p class="text">{{ $t('support.email') }}</p>
						</address>
						<address class="contact-form__address">
							<h2 class="">{{ $t('support.technicalSupport') }}</h2>
							<!-- <p class="text">{{ $t('support.phone') }}</p> -->
							<p class="text">{{ $t('support.openingHours') }}</p>
							<p class="text">{{ $t('support.email') }}</p>
							<p class="text"><a href="https://prospectsinc.zendesk.com/hc" target="_blank" class="link">{{ $t('nav.helpCenter') }}</a></p>
						</address>
						<address class="contact-form__address">
							<h2 class="">{{ $t('support.montrealOffice') }}</h2>
							<p class="text">{{ $t('support.addressLine1') }}</p>
							<p class="text">{{ $t('support.addressLine2') }}</p>
							<p class="text">{{ $t('support.addressLine3') }}</p>
						</address>
					</div>
				</section>
			</div>
		</div>
  </div>
</template>


<script>
import Introducer from '@/components/utils/Introducer.vue'

export default {
	components: { Introducer },

	mounted () {
		grecaptcha.render('g-recaptcha');
	},

	data () {
		return {
			name: null,
			email: null,
			message: null,
			formSent: false
		}
	},

	computed: {

	},

	methods: {
		submitForm() {
			this.formSent = false;

			var formData = new FormData();
			formData.append("name", this.name);
			formData.append("email", this.email);
			formData.append("message", this.message);
			formData.append("recapcha", document.querySelector('textarea[name="g-recaptcha-response"]').value);

			var xhr = new XMLHttpRequest();
			xhr.open("POST", "/mailer/mailer.php");
			xhr.send(formData);

			xhr.onreadystatechange = () => {
				if (xhr.readyState === 4 && xhr.status == 201) {
					this.name = "";
					this.email = "";
					this.message = "";
					this.formSent = true;
				}
			};
		}
	}
}
</script>

<style scoped>
	.contact-form--support { background: url('./../../assets/pages/about/map.jpg') no-repeat center; background-attachment: fixed; background-size: cover;}
	.contact-form--support::after { background: url('./../../assets/pages/about/photo-stack.png') no-repeat right; background-size: auto 100%;}
	.contact-form__wrapper { display: flex; flex-wrap: wrap; position:relative; z-index:1; }
	.contact-form__form { width: 50%; }
	.contact-form__info { margin-left: 40px; flex:1; }
	.contact-form__address { font-style: normal; }
	.contact-form__address h2 { color: #cc0000; font-weight: 600; text-decoration: underline; margin:0; margin-top: 20px; font-size: 2rem; }
	.contact-form__address p { margin: 5px 0; }
	.contact-form__success { display: none; border: 1px solid #8fbe32; padding: 15px 15px; background: #8fbe32; border-radius: 10px; color: white; }
	.contact-form__success--visible { display: block; }

	.form__label, .form__input, .form__textarea { width: 100%; display: block; }
	.form__input, .form__textarea { margin-top: 4px; padding: 10px 5px; border: 1px solid #c7c7c9; border-radius: 3px; outline: none; box-sizing: border-box; }
	.form__input:focus, .form__textarea:focus { border: 1px solid #d02627; }
	.form__textarea { height: 100px; }

	.contact-form label { margin-top: 20px; }
	.contact-form textarea { margin-bottom: 20px; }

	.people { display: flex; flex-direction: column; align-items: center; text-align: center; }
	.people__image { height: 200px; border-radius: 50%; overflow: hidden; }
	.people__name { margin-top: 20px; font-size: 2rem; }
	. { font-weight: bold; margin: 10px 0; font-style: italic; }
	.people__description, .people__name, . { display: block; }

	@media (max-width: 1400px) {
		.contact-form::after { content: none; }
	}

	@media (max-width: 900px) {
		.contact-form__wrapper { display: flex; position:relative; z-index:1; }
		.contact-form__form { flex: 0 0 100%; }
		.contact-form__info { flex: 0 0 100%; margin-left: 0; padding-top: 40px; }
		.contact-form__addresses { display: flex; flex-wrap: wrap; margin: -40px 0 0 -40px; }
		.contact-form__address { flex: 1; padding: 40px 0 0 40px; }
	}
</style>
